import React, { useContext, useEffect, useState } from 'react';
import { back } from '../../helpers/dataServer';
import { UserContext } from '../auth/context/UserContext';
import ItemUsuarioClienteSelect from './ItemUsuarioClienteSelect';
import './css/ItemUsuarioCliente.css';

import Modal from '../Modal/Modal';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const ItemUsuarioCliente = ({ usuario }) => {
  const [perfiles, setPerfiles] = useState([]);
  const [usuarioClientes, setUsuarioClientes] = useState([]);
  const [abierto, setAbierto] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const { dataUser } = useContext(UserContext);
  const { token } = dataUser;

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    fetch(`${back}/usuarios/listusuarios`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => setPerfiles(data.data))
      .catch((error) => {
        console.error('Error al obtener la lista de perfiles:', error);
      });

    const fetchUsuarioClientes = async () => {
      try {
        const response = await fetch(`${back}/usuarioclientes/${usuario.id}`, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            method: 'GET',
          },
        });
        const data = await response.json();

        if (data.status === 200 && Array.isArray(data.data)) {
          setUsuarioClientes(data.data);
        } else {
          console.error('Error al obtener clientes asignados:', data);
          setUsuarioClientes([]);
        }
      } catch (error) {
        console.error('Error al obtener los clientes asignados:', error);
        setUsuarioClientes([]);
      }
    };

    fetchUsuarioClientes();
  }, [token, usuario.id]);

  const toggleAcordeon = () => {
    setAbierto(!abierto);
  };

  const setClientesActualizados = (clientesActualizados) => {
    setUsuarioClientes(clientesActualizados);
  };

  const handleEliminarCliente = async (clienteId) => {
    const confirmacion = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará al cliente asignado.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const response = await fetch(`${back}/usuarioclientes/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          id_usuario: usuario.id,
          id_cliente: clienteId,
        }),
      });

      if (response.ok) {
        setUsuarioClientes((prev) => prev.filter((c) => c.id !== clienteId));
        Swal.fire('Eliminado', 'Cliente eliminado correctamente.', 'success');
      } else {
        Swal.fire('Error', 'No se pudo eliminar el cliente.', 'error');
      }
    } catch (error) {
      console.error('Error al eliminar el cliente:', error);
      Swal.fire('Error', 'Ocurrió un problema con la eliminación.', 'error');
    }
  };

  return (
    <div className="GrandContainerGestionP">
      <div className="contenedortabla" onClick={toggleAcordeon}>
        <article
          className="tablaUsuarioPerfils"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1%',
          }}
        >
          <div className="divUsuario">
            <div className="imgUsuario">
              <img
                className="imgGestPerfil"
                src={usuario.imagen}
                alt="Imagen de perfil"
              />
            </div>
            <div className="nameUsuario">
              <span className="nombreGestPerfil">
                {usuario.nombre} {usuario.apellido}
              </span>
            </div>
          </div>
          <div className="clientesAsignados">
            <h3>Clientes asignados:</h3>

            {usuarioClientes.length > 0 ? (
              <ul className="ulClienteUsu">
                {usuarioClientes.map((cliente) => (
                  <li className="clienteItem" key={cliente.id}>
                    <span className="pill">{cliente.denominacion}</span>
                    <button
                      className="closeBtnn"
                      onClick={() => handleEliminarCliente(cliente.id)}
                      closeBtn
                    >
                      <FontAwesomeIcon
                        icon={faXmark}
                        width={24}
                        height={24}
                        alt="close"
                      />
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No hay clientes asignados.</p>
            )}

            {modalOpen && (
              <Modal titulo={'Clientes'} cerrarModal={closeModal}>
                <ItemUsuarioClienteSelect
                  usuario={usuario}
                  perfiles={perfiles}
                  abierto={abierto}
                  cerrarModal={closeModal}
                  toggleAcordeon={toggleAcordeon}
                  setClientesActualizados={setClientesActualizados}
                />
              </Modal>
            )}
          </div>
          <button className="btnAbrirModal" onClick={openModal}>
            Editar
          </button>
        </article>
      </div>
      <hr />
    </div>
  );
};

export default ItemUsuarioCliente;
